<template>
    <div class="body-container">
        <BannerSection title="Préstamos por auto sin dejarlo"
                       subtitle="Rápido, seguro y sin dejar de usar tu auto" />
        <PerksComponent></PerksComponent>
        <div class="section-container regular-text">
            <div class="position-relative  pb-3 pb-md-0 ">
                <div class="text-container">
                    <h1 class="title"><b>Préstamos por auto sin dejarlo</b></h1>
                    <p class="regular-text">
                        ¿Te imaginas obtener un préstamo sin renunciar a tu auto y seguir manejándolo como siempre?
                    </p>
                    <p class="regular-text">
                        Si buscas una solución financiera rápida y efectiva, los <b>préstamos por auto sin dejarlo
                        </b>son una excelente alternativa.
                    </p>
                    <p class="regular-text">
                        Descubre en este artículo cómo funcionan, qué necesitas y por qué son una opción cada vez más
                        popular entre los mexicanos
                    </p>
                    <br>
                    <span>
                        <h2 class="h2-title"><b>¿Cómo funcionan los préstamos por auto sin dejarlo?</b></h2>
                    </span>
                    <p class="regular-text">
                        Los <b>préstamos con garantía automotriz</b> te permiten obtener dinero utilizando tu vehículo como
                        respaldo, pero sin tener que entregarlo o dejar de usarlo. En <b>Ibancar</b>, por ejemplo, el proceso
                        es sencillo y completamente en línea:
                    </p>
                    <ul>
                        <li>
                            <p class="regular-text"><b>Solicitud rápida:</b> Rellena un formulario desde la
                                comodidad de tu casa.</p>
                        </li>
                        <li>
                            <p class="regular-text"><b>Preaprobación inmediata:</b> Con unos cuantos datos de tu auto,
                                recibes una respuesta en minutos.</p>
                        </li>

                        <li>
                            <p class="regular-text"><b>Evaluación del vehiculo:</b> Se toma en cuenta el valor del auto
                                según su modelo, año y condiciones.</p>
                        </li>
                        <li>
                            <p class="regular-text"><b>Revisión técnica del vehículo:</b> un profesional se acercará a
                                verificar el estado del vehículo y recoger la factura.</p>
                        </li>
                        <li>
                            <p class="regular-text"><b>Transferencia inmediata:</b> En cuanto se firme el contrato, se
                                realizará la transferencia para que dispongas de ella cuanto antes.</p>
                        </li>
                        <li>
                            <p class="regular-text"><b>Entrega del préstamo:</b> En menos de 24 horas, el dinero estará
                                en tu cuenta mientras sigues manejando tu auto.</p>
                        </li>
                    </ul>
                    <p class="regular-text">Este modelo es ideal para quienes necesitan liquidez inmediata, sin
                        complicaciones ni interrupciones en su día a día. </p>
                    <br>

                    <h2 class="h2-title"><b>Requisitos para obtener préstamos por auto sin dejarlo</b></h2>

                    <p class="regular-text">Aunque los requisitos pueden variar según la institución, en general
                        necesitarás lo siguiente:
                    </p>

                    <ul>
                        <li>
                            <p class="regular-text"><b>Factura del auto:</b> (de agencia ó refactura).</p>
                        </li>
                        <li>
                            <p class="regular-text">Identificaión oficial vigente. ( <b>INE</b> )</p>
                        </li>
                        <li>
                            <p class="regular-text">Comprobante de domicilio e ingresos recientes.</p>
                        </li>
                    </ul>

                    <p class="regular-text">En <b>Ibancar</b>, aceptamos personas en Buró de Crédito y ofrecemos condiciones
                        flexibles para que más mexicanos puedan acceder a este tipo de financiamiento.</p>

                    <br>
                    <h2 class="h2-title">
                        <b> Ventajas de los préstamos por carro sin dejarlo</b>
                    </h2>
                    <p class="regular-text">Optar por un <b>préstamo con garantía de auto sin dejarlo</b> tiene
                        múltiples beneficios:</p>
                    <ul>
                        <li class="mb-0 regular-text">
                            <p class="mb-0 regular-text">
                                <b>Flexibilidad</b>
                            </p>
                            <p class="regular-text"> Sigues utilizando tu auto sin restricciones.</p>
                        </li>

                        <li class="mb-0 regular-text">
                            <p class="mb-0 regular-text">
                                <b>Rapidez:</b>
                            </p>
                            <p class="regular-text">El dinero puede estar en tu cuenta en menos de 24 horas</p>
                        </li>


                        <li class="mb-0 regular-text">
                            <p class="mb-0 regular-text">
                                <b>Seguridad</b>
                            </p>
                            <p class="regular-text">Todo el proceso es transparente y sin sorpresas.

                            </p>
                        </li>

                        <li class="mb-0 regular-text">
                            <p class="mb-0 regular-text">
                                <b>Aportes a capital</b>
                            </p>
                            <p class="regular-text">Desde el primer pago, reduces tu deuda principal.

                            </p>
                        </li>
                    </ul>
                    <p class="regular-text">Estas ventajas hacen que este tipo de préstamos sean ideales para quienes
                        necesitan dinero de forma urgente pero no quieren perder su patrimonio.
                    </p>
                    <br>
                    <h2 class="h2-title">
                        <b>Riesgos y consideraciones al solicitar este tipo de préstamos</b>
                    </h2>
                    <p class="regular-text">Aunque los préstamos sobre vehículo son una gran opción, es importante tomar
                        en cuenta algunos puntos:</p>
                    <ul>
                        <li>
                            <p class="regular-text">
                                <b>Intereses y costos adicionales:</b> Consulta todas las tasas y comisiones antes de
                                firmar.
                            </p>
                        </li>
                        <li>
                            <p class="regular-text">
                                <b>Compromiso de pago:</b> Cumple puntualmente con las mensualidades para evitar
                                problemas legales.
                            </p>
                        </li>
                    </ul>
                    <p class="regular-text">
                        En <b>Ibancar</b>, te ofrecemos una asesoría personalizada para resolver cualquier duda antes de
                        que tomes una decisión.
                    </p>
                    <br>
                    <h2 class="h2-title">
                        <b>Comparativa de empresas que ofrecen préstamos por auto sin dejarlo</b>
                    </h2>
                    <p class="regular-text">Entre las opciones disponibles en México, <b>Ibancar</b> destaca por:</p>
                    <ul>
                        <li class="mb-0 regular-text">
                            <p class="mb-0 regular-text">
                                <b>Proceso en linea:</b>
                            </p>
                            <p>Sin necesidad de salir de casa.</p>
                        </li>

                        <li class="mb-0 regular-text">
                            <p class="mb-0 regular-text">
                                <b>Rápida aprobación:</b>
                            </p>
                            <p class="regular-text">Respuesta en minutos y entrega del dinero en 24 horas.</p>
                        </li>

                        <li class="mb-0 regular-text">
                            <p class="mb-0 regular-text">
                                <b>Condiciones claras:</b>
                            </p>
                            <p class="regular-text">Sin cláusulas ocultas ni pagos finales inesperados.
                            </p>
                        </li>
                    </ul>
                    <p class="regular-text">
                        Al elegir una empresa, verifica que tenga buena reputación, opiniones positivas y que esté
                        registrada en organismos como PROFECO.
                    </p>
                </div>
            </div>
        </div>


        <div style="background-color: rgba(255, 165, 0, 0.04); padding: 1.5rem 0rem; margin: 0rem 0rem;">
            <div class="ibancar-election">
                <p>¿Por qué elegir Ibancar?</p>
            </div>
            <BeneficiosIbancarCarousel />
        </div>


        <div class="section-container regular-text">
            <div class="position-relative  pb-3 pb-md-0 ">
                <div class="text-container">
                    <br>

                    <span class="bold-text">
                        <b>
                            <h2 class="h2-title">FAQs sobre el Préstamo personal</h2>
                        </b>
                    </span>
                    <br>

                    <div>
                        <p style="font-size: 23px; font-style: italic;"
                           class="regular-text">- ¿Puedo solicitar un préstamo si estoy en Buró de Crédito?</p>
                        <p class="regular-text">¡Sí! En Ibancar aceptamos personas con Buró, evaluando principalmente el valor de tu auto.</p>
                    </div>
                    <div>
                        <p style="font-size: 23px; font-style: italic;"
                           class="regular-text">-¿Qué pasa si no puedo pagar?
                        </p>
                        <p class="regular-text">En caso de incumplimiento, es importante mantener una comunicación abierta con tu asesor para llegar a una solución. </p>
                    </div>
                    <div>
                        <p style="font-size: 23px; font-style: italic;"
                           class="regular-text">-  ¿Cuánto dinero puedo obtener?</p>
                        <p class="regular-text">Dependiendo del valor de tu auto, puedes obtener desde $12,000 hasta $120,000 MXN.
                        </p>
                    </div>
                    <br>
                    <p class="regular-text">Los <b>préstamos por factura de carro</b> son una excelente alternativa para quienes buscan liquidez inmediata sin comprometer el uso de su vehículo. En <b>Ibancar</b>, simplificamos el proceso para que tengas tu dinero rápido, con condiciones claras y seguras.  </p>
                    <p class="regular-text">¿Listo para dar el primer paso? ¡Solicita tu préstamo ahora y obtén el dinero que necesitas sin dejar de manejar tu auto!</p>
                </div>

            </div>

        </div>
        <SolicitaloBannerS2 />
    </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import BannerSection from '@/components/Landings/BannerSection.vue';
import BeneficiosIbancarCarousel from '@/components/PrestamoGarantiaAuto/BeneficiosIbancarCarousel.vue';
import SolicitaloBannerS2 from '@/components/Landings/SolicitaloBannerS2.vue';
import PerksComponent from '../components/PerksComponent.vue';


export default {
    name: 'PrestamoPorAutoSinDejarlo',
    components: {
        BannerSection,
        BeneficiosIbancarCarousel,
        SolicitaloBannerS2,
        PerksComponent
    },
    setup() {
        useMeta(
            {
                title: 'Préstamos por auto sin dejarlo | IBANCAR México',
                meta: [
                    {
                        name: 'robots',
                        content: 'index'
                    },
                    {
                        name: 'description',
                        content: 'Obtén préstamos por auto sin dejarlo con IBANCAR México. Descubre cómo funcionan, requisitos y ventajas para tomar la mejor decisión. ¡Infórmate ahora!'
                    },
                    {
                        name: 'keywords',
                        content: 'prestamos por auto sin dejarlo'
                    }
                ],
                link: [
                    { href: 'https://ibancar.mx/prestamo-auto-sin-dejarlo', rel: 'alternate', hreflang: 'es-MX' }
                ]
            }
        )
    },

    data() {
        return {
            ventajas: [
                {
                    image: 'image12.svg',
                    title: 'Ejecutivo personalizado',
                },
                {
                    image: 'solicitud-en-linea.svg',
                    title: 'Proceso simple sin salir de casa',
                },

                {
                    image: 'prestamos-48-hrs.svg',
                    title: 'Hasta $120,000 en 24H',
                },
                {
                    image: 'proceso-simple.svg',
                    title: 'Aceptamos personas en Buró.',
                }

            ]
        }
    }
}
</script>

<style scoped lang="scss">
@import 'bootstrap/scss/_functions.scss';
@import 'bootstrap/scss/_variables.scss';
@import 'bootstrap/scss/_mixins.scss';


.image-container {
    text-align: center;
    margin: 3rem 0rem;

    img {
        max-height: 400px;
    }
}

.body-container {
    margin-top: 4.5rem;
    min-height: calc(100vh - 115px);
}

@include media-breakpoint-up(md) {
    .body-container {
        margin-top: 8.5rem;
    }
}

.ibancar-election {
    margin: 1rem 2rem 0rem 2rem;

    p {
        color: #004680;
        text-align: center;
        font-family: 'Montserrat-Bold';
        font-size: 1.3rem;
        font-style: normal;
        line-height: normal;
        margin: 1.5rem 0rem;
    }
}

.text-container {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    font-size: 20px;
    text-align: justify;
}

.regular-text {
    font-family: "Montserrat";
    font-size: 20px;
    line-height: 30px;
}

.bold-text {
    font-family: "Montserrat-Bold";
}

.text-orange {
    color: $orange;
}

.text-blue {
    color: $blue;
}

.text-black {
    color: $black;
}

.text-underline {
    text-decoration: underline;
}


.btn-solicitar {
    a {
        &:hover {
            text-decoration: none;
        }
    }
}

// Image
.image {
    bottom: 0;
    right: 0;
    width: 30%;
    z-index: -1;
}

@include media-breakpoint-down(md) {
    .text-container {
        width: 90%;
    }

    .regular-text {
        line-height: 1.5;
    }

    ul {
        padding-inline-start: 20px;
    }

    ol {
        padding-inline-start: 20px;
    }

    p,
    h1,
    h2,
    h3,
    h4 {
        text-align: left;
    }
}

@include media-breakpoint-between(md, lg) {
    .regular-text {
        font-size: 16px;
    }

    .subtitle {
        font-size: 16px;
    }
}

@include media-breakpoint-down(sm) {
    .title {
        font-size: 23px;
        line-height: 25px;
    }

    .h2-title {
        font-size: 18px;
        line-height: 20px;
    }

    .h3-title {
        font-size: 16px;
        line-height: 15px;
    }

    .regular-text {
        font-size: 14px !important;
    }

    .section-container {
        margin-top: 1.5rem;
    }
}
</style>